import * as React from 'react';
import {
  Logging,
  API,
  ResponseError,
  NotificationData,
  TaxResult,
} from '@vcd-ecm-ui/Common';
import { useDispatch } from 'react-redux';

const useTaxResults = (
  gatewayEndPoint: string,
): [TaxResult[], NotificationData] => {
  const [taxResults, setTaxResults] = React.useState(null);
  const [taxResultNotification, setTaxResultNotification] = React.useState(null);
  const dispatch = useDispatch();

  const getTaxResults = () => async (): Promise<void> => {
    try {
      const api = new API(gatewayEndPoint);

      // FIX ME
      // const taxResultList: TaxResult[] = await api.report.getTaxResultsV41();

      const taxResultList: TaxResult[] = [
        {
          id: 1,
          name: 'Exempt',
        },
        {
          id: 2,
          name: 'Zero Rate',
        },
      ];

      Logging.Debug('Get Tax Results:', taxResultList);

      // Save the Tax Results to the Session Storage
      sessionStorage.taxResults = JSON.stringify(taxResultList);

      setTaxResults(taxResultList);
    } catch (error) {
      const notification: NotificationData = {
        type: 'Error',
        title: 'Tax Results Read Error',
        description: 'Unable to read Tax Results',
        error: error as ResponseError,
      };
      setTaxResultNotification(notification);
    }
  };

  React.useEffect(() => {
    if (!taxResults) {
      // Read the Tax Results from the Session Storage if available
      if (sessionStorage.taxResults) {
        setTaxResults(JSON.parse(sessionStorage.taxResults));
      } else {
        dispatch(getTaxResults());
      }
    }

    return (): void => {
      setTaxResultNotification(null);
    };
  }, []);

  return [taxResults, taxResultNotification];
};

export default useTaxResults;
